import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import 'svgxuse';
import { sprite } from './sprite';
var _Flag = function (props) {
    var _a = props.name, name = _a === void 0 ? 'INT' : _a;
    React.useEffect(function () {
        // create and append sprite to consumer body
        if (!document.getElementById('flagSprite')) {
            var svgsprite = document.createElement('div');
            svgsprite.innerHTML = sprite.trim();
            svgsprite.id = 'flagSprite';
            svgsprite.style.display = 'none';
            document.body.appendChild(svgsprite);
        }
    }, []);
    return (React.createElement("svg", { className: props.className, preserveAspectRatio: "xMidYMid meet" },
        React.createElement("use", { xlinkHref: "sprite#" + name })));
};
export var Flag = styled(_Flag)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 20px;\n  height: 15px;\n  vertical-align: middle;\n"], ["\n  width: 20px;\n  height: 15px;\n  vertical-align: middle;\n"])));
Flag.displayName = 'Flag';
var templateObject_1;
//# sourceMappingURL=Flag.js.map